import { AppScheme } from "@fe_utils/fe_sdk_base";

export const appsConfig = [
  {
    name: "piano",
    appName: "来音钢琴",
    schemeName: AppScheme.Xihangpiano,
    phoneCardBgImg: require("./image/piano_phone_card_bg_img.png"),
    pcCardBgImg: require("./image/piano_pc_card_bg_img.png"),
    appIcon: require("./image/piano_icon.png"),
    appIntr: ["口袋里的", "完美电子钢琴键盘", "🎹🎹🎹"],
  },
  {
    name: "metronome",
    appName: "来音节拍器",
    schemeName: AppScheme.Metronome,
    phoneCardBgImg: require("./image/metronome_phone_card_bg_img.png"),
    pcCardBgImg: require("./image/metronome_pc_card_bg_img.png"),
    appIcon: require("./image/metronome_icon.png"),
    appIntr: ["顶级音乐家推荐的手机节拍器！", "比物理节拍器更好用！", "🎵🎶🎵"],
  },
  {
    name: "tuner",
    appName: "来音调音器",
    schemeName: AppScheme.Laiyintuner,
    phoneCardBgImg: require("./image/tuner_phone_card_bg_img.png"),
    pcCardBgImg: require("./image/tuner_pc_card_bg_img.png"),
    appIcon: require("./image/tuner_icon.png"),
    appIntr: ["支持多种乐器精准调音", "让你的乐器不再走音", "🎶🎶🎶"],
  },
  {
    name: "launchpad",
    appName: "打击垫",
    schemeName: "",
    phoneCardBgImg: require("./image/launchpad_phone_card_bg_img.png"),
    pcCardBgImg: require("./image/launchpad_pc_card_bg_img.png"),
    appIcon: require("./image/launchpad_icon.png"),
    appIntr: ["有了电音打击垫", "你也可以做DJ", "⚡️🎧⚡️"],
  },
  {
    name: "rhythm",
    appName: "懂音律",
    schemeName: AppScheme.Rhythm,
    phoneCardBgImg: require("./image/rhythm_phone_card_bg_img.png"),
    pcCardBgImg: require("./image/rhythm_pc_card_bg_img.png"),
    appIcon: require("./image/rhythm_icon.png"),
    appIntr: ["别再费劲找谱了", "帮你把海量乐谱装进手机", "🎵🎵🎵"],
  },
  {
    name: "guitar",
    appName: "来音吉他",
    schemeName: AppScheme.Laiyinguitar,
    phoneCardBgImg: require("./image/guitar_phone_card_bg_img.png"),
    pcCardBgImg: require("./image/guitar_pc_card_bg_img.png"),
    appIcon: require("./image/guitar_icon.png"),
    appIntr: ["零基础轻松学会吉他弹唱", "像专业吉他手一样演奏", "🎸🎸🎸"],
  },
  {
    name: "partner_training_s",
    appName: "来音练琴",
    schemeName: AppScheme.Partnertrainingstudent,
    phoneCardBgImg: require("./image/partner_training_s_phone_card_bg_img.png"),
    pcCardBgImg: require("./image/partner_training_s_pc_card_bg_img.png"),
    appIcon: require("./image/partner_training_s_icon.png"),
    appIntr: ["名校老师在线1对1指导，", "让孩子练琴更轻松！", "🎹🎹🎹"],
  },
  {
    name: "partner_training_t",
    appName: "来音老师端",
    schemeName: AppScheme.Partnertrainingteacher,
    phoneCardBgImg: require("./image/partner_training_s_phone_card_bg_img.png"),
    pcCardBgImg: require("./image/partner_training_s_pc_card_bg_img.png"),
    appIcon: require("./image/partner_training_t_icon.png"),
    appIntr: ["真正实现老师做主，", "足不出户就能轻松赚钱的平台", "🎹🎹🎹"],
  },
  {
    name: "partner_training_s_ai",
    appName: "来音智能陪练",
    schemeName: AppScheme.Partnertrainingai,
    phoneCardBgImg: require("./image/partner_training_s_ai_phone_card_bg_img.png"),
    pcCardBgImg: require("./image/partner_training_s_ai_pc_card_bg_img.png"),
    appIcon: require("./image/partner_training_s_ai_icon.png"),
    appIntr: ["能帮你实时纠正错音的", "练琴神器正在免费", "快来试试吧！"],
  },
  {
    name: "tunerfence",
    appName: "来音调音器",
    schemeName: AppScheme.Newlaiyintuner,
    phoneCardBgImg: require("./image/tunerfence_phone_card_bg_img.png"),
    pcCardBgImg: require("./image/tunerfence_pc_card_bg_img.png"),
    appIcon: require("./image/tunerfence_icon.png"),
    appIntr: ["支持多种乐器精准调音", "让你的乐器不再走音", "🎶🎶🎶"],
  },
  {
    name: "music_knowledge",
    appName: "乐理手册",
    schemeName: AppScheme.Laiyinmusictheory,
    phoneCardBgImg: require("./image/music_knowledge_phone_card_bg_img.png"),
    pcCardBgImg: require("./image/music_knowledge_pc_card_bg_img.png"),
    appIcon: require("./image/music_knowledge_icon.png"),
    appIntr: ["音基考级知识大全", "你的音乐学习助手", "🎵🎵🎵"],
  },
  {
    name: "guzheng",
    appName: "来音古筝",
    schemeName: AppScheme.Flutterguzheng,
    phoneCardBgImg: require("./image/guzheng_phone_card_bg_img.png"),
    pcCardBgImg: require("./image/guzheng_pc_card_bg_img.png"),
    appIcon: require("./image/guzheng_icon.png"),
    appIntr: ["真实的古筝模拟器", "随心演奏喜欢的曲目", "🎵🎵🎵"],
  },
  {
    name: "editscore",
    appName: "来音制谱",
    schemeName: AppScheme.Laiyineditscore,
    phoneCardBgImg: require("./image/editscore_phone_card_bg_img.png"),
    pcCardBgImg: require("./image/editscore_pc_card_bg_img.png"),
    appIcon: "https://static.quthing.com/fe/img/base/lyzp_icon.png",
    appIntr: ["简单高效的打谱软件", "自动生成智能乐谱", "🎶🎶🎶"],
  },
];
